module.exports = __webpack_public_path__ + "statics/media/aspire-logo_color_no-claim.0c8be59a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/aspire-logo/aspire-logo_color_no-claim.svg
// module id = 1214
// module chunks = 138